import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { hikari } from './Hikari';
import { mobile } from './Mobile';
import { vas } from './Vas';
import { prepaidSim } from './prepaidSim';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
  },
  modules: {
    hikari,
    mobile,
    vas,
    prepaidSim,
  },
};

export default new Vuex.Store<RootState>(store);
